import React, { useState } from "react";
import { FormControl, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useSnackbar } from "notistack";
import { _add_customer } from "../../DAL/Customers/Customers";
import { s3baseUrl } from "../../config/config";

export default function AddCustomer({
  onCloseDrawer,
  apiFunction,
  setCustomerList,
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [previews, setPreviews] = useState("");
  const [image, setImage] = useState("");
  const [inputs, setInputs] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    contact_number: "",
    address: "",
  });
  const { enqueueSnackbar } = useSnackbar();

  const handleRemove = () => {
    setPreviews("");
    setImage("");
  };
  const handleUpload = (event) => {
    setImage(event.target.files[0]);
    const preview = URL.createObjectURL(event.target.files[0]);
    setPreviews(preview);
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setInputs((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    const formData = new FormData();
    formData.append("first_name", inputs.first_name);
    formData.append("last_name", inputs.last_name);
    formData.append("email", inputs.email);
    formData.append("contact_number", inputs.contact_number);
    formData.append("address", inputs.address);
    formData.append("password", inputs.password);
    if (image) {
      formData.append("profile_image", image);
    }
    setIsLoading(true);
    const response = await _add_customer(formData);

    if (response.code === 200) {
      let response_object = response.customer;
      response_object.customer_image = {
        src: s3baseUrl + response.customer.profile_image,
        alt: response.customer.first_name,
      };
      setCustomerList((prev) => [response_object, ...prev]);
      apiFunction();
      onCloseDrawer();
      enqueueSnackbar(response.message, { variant: "success" });
      setIsLoading(false);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setIsLoading(false);
    }
  };
  return (
    <div className="container new-memories">
      <form onSubmit={handleSubmit}>
        <div className="col-12">
          <FormControl fullWidth sx={{ mt: 2, mb: 2 }}>
            <TextField
              id="outlined-basic"
              label="First Name"
              variant="outlined"
              sx={{ width: "100%" }}
              required
              name="first_name"
              value={inputs?.first_name}
              onChange={handleChange}
            />
          </FormControl>
        </div>
        <div className="col-12">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              id="outlined-basic_1"
              label="Last Name"
              variant="outlined"
              sx={{ width: "100%" }}
              required
              name="last_name"
              value={inputs?.last_name}
              onChange={handleChange}
            />
          </FormControl>
        </div>
        <div className="col-12">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              id="outlined-basic_2"
              label="Email"
              variant="outlined"
              type="email"
              sx={{ width: "100%" }}
              required
              name="email"
              value={inputs?.email}
              onChange={handleChange}
            />
          </FormControl>
        </div>

        <div className="col-12">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              id="outlined-basic_3"
              label="Password"
              variant="outlined"
              sx={{ width: "100%" }}
              required
              type="password"
              name="password"
              value={inputs?.password}
              onChange={handleChange}
            />
          </FormControl>
        </div>

        <div className="col-12">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="Contact No."
              id="outlined-basic_4"
              type="number"
              variant="outlined"
              sx={{ width: "100%" }}
              name="contact_number"
              value={inputs?.contact_number}
              onChange={handleChange}
            />
          </FormControl>
        </div>
        <div className="col-12">
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              id="outlined-basic-5"
              label="Address"
              variant="outlined"
              sx={{ width: "100%" }}
              // required
              name="address"
              value={inputs?.address}
              onChange={handleChange}
            />
          </FormControl>
        </div>

        <p className="mt-2 mb-0">Upload Image (1000x670)</p>
        <div className="col-md-12 mt-2 d-flex">
          {previews && (
            <span className="preview mt-2">
              <span onClick={handleRemove}>x</span>
              <img src={previews} />
            </span>
          )}
          {previews == "" && (
            <span className="upload-button mt-2">
              <input
                color="primary"
                accept="image/*"
                type="file"
                id="icon-button-file"
                style={{ display: "none" }}
                name="profile_image"
                onChange={handleUpload}
              />
              <label htmlFor="icon-button-file">
                <CloudUploadIcon />
              </label>
            </span>
          )}
        </div>

        <div className="text-end mt-3 mb-3">
          <button className="small-contained-button" disabled={isLoading}>
            {isLoading ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
